module.exports = __webpack_public_path__ + "fonts/NanumSquareOTFR.011c8c41.woff2";